import React, { useEffect, useState } from "react"
import { Label } from "reactstrap"

const TagInput = ({
  title = "",
  star,
  onChange,
  tags,
  classNameTag,
  buttonTitle = "",
  onAddClick,
}) => {
  //   const [tags, setTags] = useState([])
  const [input, setInput] = useState("")

  //   useEffect(() => {
  //     onChange(tags)
  //   }, [tags])

  const addTag = value => {
    const v = value.trim()
    if (!v) return
    if (tags.includes(v)) return
    // setTags(prev => [...prev, v])
    onChange([...tags, v])
    setInput("")
  }

  const removeTag = index => {
    // setTags(prev => prev.filter((_, i) => i !== index))
    onChange(tags.filter((_, i) => i !== index))
  }

  const onKeyDown = e => {
    if (e.key === "Enter") {
      e.preventDefault()
      addTag(input)
    } else if (e.key === "Backspace" && input === "" && tags.length) {
      // remove last tag on backspace when input empty
      removeTag(tags.length - 1)
    }
  }

  const handleAddClick = () => {
    addTag(input)
    if (onAddClick) {
      onAddClick(input, [...tags, input.trim()])
    }
  }

  return (
    <div className="w-full">
      <div className="d-flex align-items-center flex-wrap">
        <Label className="mb-2 px-1">
          {title} <span style={{ color: "red" }}>{star}</span>
        </Label>
        <small className="form-text text-muted mt-1 mb-1 px-1">
          Press Enter to add. Click × to remove.
        </small>
      </div>
      <div className={`d-flex flex-column ${classNameTag}`}>
        <div className="d-flex taginput-inline">
          <input
            type="text"
            className="form-control"
            placeholder="Type and press Enter to Save"
            value={input}
            onChange={e => setInput(e.target.value)}
            onKeyDown={onKeyDown}
          />
          {onAddClick && (
            <button
              type="button"
              className="btn btn-secondary"
              onClick={handleAddClick}
              disabled={!input.trim()}
            >
              {buttonTitle}
            </button>
          )}
        </div>
        <div className="d-flex align-items-center flex-wrap">
          {tags.map((tag, idx) => (
            <span key={`${tag}-${idx}`} className="tags-pills">
              <span>{tag}</span>
              <button
                type="button"
                onClick={() => removeTag(idx)}
                className="btn-close tags-close-pill"
                aria-label="Remove"
              />
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}

export default TagInput
